// Link an existing folder — attach local notes to a vault, with the
// merge-on-join preview + backup. Sourced from specs/cli.md §5.

import { IconLink, IconLinkOff, IconShieldCheck } from "@tabler/icons-react";
import { CommandLine } from "@/components/command-line";
import { DocSection, K, P, Points } from "../doc-ui";

export function LinkFolderDoc() {
  return (
    <>
      <P>
        Linking is for a folder that already has notes in it. Where <K>clone</K> starts from an
        empty folder and pulls, <K>link</K> starts from your existing content and joins it to a
        vault — safely, with a preview and a backup before anything merges.
      </P>

      <DocSection icon={IconLink} title="Link a folder">
        <CommandLine
          command="cairn vault link <path>"
          comment="create a NEW vault from this folder"
        />
        <CommandLine
          command="cairn vault link <path> --vault <id>"
          comment="attach the folder to an EXISTING vault"
        />
        <P>
          Like clone, this installs and configures the plugin in the folder. The difference is
          what happens on first open in Obsidian.
        </P>
      </DocSection>

      <DocSection
        icon={IconShieldCheck}
        title="The first open: preview + backup"
        description="Joining existing content to existing content is the one risky moment, so it's guarded."
      >
        <Points>
          <li>
            When you open the linked folder in Obsidian, the plugin shows a merge preview: what
            will be pulled in, and how local files reconcile with remote ones.
          </li>
          <li>A backup of the folder is written outside the vault before the merge runs.</li>
          <li>Only after you confirm does the folder start syncing. This flow is desktop-only —
            phones can't link populated folders.</li>
        </Points>
      </DocSection>

      <DocSection
        icon={IconLinkOff}
        title="Unlink"
        description="Stop a folder syncing without touching the vault."
      >
        <CommandLine command="cairn vault unlink <path>" />
        <P>
          The folder stays a normal Obsidian vault with all its files; only the binding to the
          remote vault is cleared. The remote vault and your membership are untouched — you can
          re-link or re-clone later.
        </P>
      </DocSection>
    </>
  );
}
